import {
  Box,
  Button,
  Container,
  Header,
  Alert,
  SpaceBetween,
} from '@amzn/awsui-components-console';

interface ConfigErrorPageProps {
  onRetry: () => void;
}

/** Displays a customer-safe configuration failure with retry guidance. */
export function ConfigErrorPage({ onRetry }: ConfigErrorPageProps) {
  return (
    <Box padding={{ vertical: 'xxxl', horizontal: 'l' }}>
      <Container>
        <SpaceBetween size="l">
          <Header variant="h1">Configuration Error</Header>

          <Alert type="error" header="Failed to load application configuration">
            The Portal configuration could not be loaded. Retry, and contact AWS Secret Region
            support if the problem continues.
          </Alert>

          <Box>
            <Button variant="primary" onClick={onRetry} iconName="refresh">
              Retry Loading Configuration
            </Button>
          </Box>
        </SpaceBetween>
      </Container>
    </Box>
  );
}
